import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { AppShell } from "@/components/AppShell";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Skeleton } from "@/components/ui/skeleton";
import { ChevronLeft, ChevronRight, Moon } from "lucide-react";

const DAYS = [["mon", "Monday"], ["tue", "Tuesday"], ["wed", "Wednesday"], ["thu", "Thursday"], ["fri", "Friday"], ["sat", "Saturday"], ["sun", "Sunday"]];

export default function ProgramDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [p, setP] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/programs/${id}`).then(({ data }) => setP(data)).finally(() => setLoading(false));
  }, [id]);

  if (loading) return <AppShell title="Program"><Skeleton className="h-64 w-full rounded-2xl bg-card" /></AppShell>;
  if (!p) return <AppShell title="Program"><p className="text-muted-foreground">Program not found.</p></AppShell>;

  return (
    <AppShell title={p.title}>
      <button onClick={() => navigate(-1)} className="flex items-center text-muted-foreground text-sm mb-3"><ChevronLeft className="h-4 w-4" /> Back</button>
      <div className="space-y-3" data-testid="program-detail">
        {p.description && <p className="text-sm text-muted-foreground">{p.description}</p>}
        {DAYS.map(([d, label]) => {
          const w = (p.day_workouts || {})[d];
          return (
            <Card key={d} data-testid={`pd-${d}`} onClick={() => w && navigate(`/workouts/${w.id}`)}
              className={`rounded-2xl bg-card border-border p-4 ${w ? "cursor-pointer hover:border-[#ccff0c]/40" : ""} transition-colors`}>
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-xs uppercase tracking-wide text-muted-foreground">{label}</p>
                  {w ? (
                    <>
                      <p className="font-semibold mt-0.5">{w.title}</p>
                      <div className="flex gap-1.5 mt-1 flex-wrap">
                        {(w.movement_patterns || []).slice(0, 3).map((mp) => (
                          <Badge key={mp} className="bg-secondary border border-border text-muted-foreground text-[10px]">{mp}</Badge>
                        ))}
                      </div>
                    </>
                  ) : (
                    <p className="font-semibold mt-0.5 flex items-center gap-1.5 text-muted-foreground"><Moon className="h-4 w-4" /> Rest day</p>
                  )}
                </div>
                {w && <ChevronRight className="h-5 w-5 text-muted-foreground" />}
              </div>
            </Card>
          );
        })}
      </div>
    </AppShell>
  );
}
